export default __webpack_public_path__ + "static/media/money-coin-sort.6a369650.svg";